import { render, staticRenderFns } from "./WelcomeImage.vue?vue&type=template&id=0ada437a&scoped=true"
import script from "./WelcomeImage.vue?vue&type=script&lang=js"
export * from "./WelcomeImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ada437a",
  null
  
)

export default component.exports